/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sub_Sport_RoadInputs */

const en_ui_sub_sport_road = /** @type {(inputs: Ui_Sub_Sport_RoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Road`)
};

const de_ui_sub_sport_road = /** @type {(inputs: Ui_Sub_Sport_RoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straße`)
};

/**
* | output |
* | --- |
* | "Road" |
*
* @param {Ui_Sub_Sport_RoadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sub_sport_road = /** @type {((inputs?: Ui_Sub_Sport_RoadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sub_Sport_RoadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sub_sport_road(inputs)
	return de_ui_sub_sport_road(inputs)
});